/**
 * ListViewToggle - Toggle between table, list and grid view modes
 */
import type { ReactElement } from 'react';

import clsx from 'clsx';
import { FaGripHorizontal, FaList, FaTable } from 'react-icons/fa';

import type { ListViewMode } from '../state/listViewSettings';

export interface ListViewToggleProps {
  value: ListViewMode;
  onChange: (mode: ListViewMode) => void;
  className?: string;
}

const VIEW_OPTIONS: { mode: ListViewMode; icon: ReactElement; label: string }[] = [
  { mode: 'table', icon: <FaTable className="h-3.5 w-3.5" />, label: 'Table view' },
  { mode: 'list', icon: <FaList className="h-3.5 w-3.5" />, label: 'Compact list view' },
  { mode: 'grid', icon: <FaGripHorizontal className="h-3.5 w-3.5" />, label: 'Grid view' },
];

export default function ListViewToggle({ value, onChange, className }: ListViewToggleProps): ReactElement {
  return (
    <div className={clsx('inline-flex rounded-lg border border-zinc-700 bg-zinc-800/50 p-0.5', className)}>
      {VIEW_OPTIONS.map(({ mode, icon, label }) => (
        <button
          key={mode}
          type="button"
          onClick={() => onChange(mode)}
          className={clsx(
            'focus-visible:ring-aether flex items-center justify-center rounded-md px-3 py-1.5 transition-all focus:outline-none focus-visible:ring-2',
            value === mode ? 'bg-zinc-700 text-zinc-100 shadow-sm' : 'text-zinc-400 hover:bg-zinc-700/50 hover:text-zinc-200',
          )}
          aria-label={label}
          aria-pressed={value === mode}
        >
          {icon}
        </button>
      ))}
    </div>
  );
}
